import { memo } from 'react';

import { PublicShowcaseNavMenuBoardItem } from '~/components/v2/components/showcase/PublicShowcaseNavMenuBoardItem';
import { PublicShowcaseNavMenuItem } from '~/components/v2/components/showcase/PublicShowcaseNavMenuItem';
import { type PublicShowcaseNavEntry } from '~/components/v2/components/showcase/publicShowcaseNavEntries';
import { usePublicShowcaseContext } from '~/providers/PublicShowcaseProvider';

export type PublicShowcaseNavMenuPageEntryProps = {
  entry: PublicShowcaseNavEntry;
};

/**
 * One page destination in the mobile nav menu (Home or a collection sub-page), plus its boards
 * nested indented beneath it — the mobile treatment of the desktop dropdown. Fetches the page's own
 * boards (deduped with the desktop bar's query for the same page); with none it renders just the
 * page item, byte-identical to before. External links never mount this component (see
 * `PublicShowcaseNavMenu`), so the board query only runs for real pages.
 */
export const PublicShowcaseNavMenuPageEntry = memo(({ entry }: PublicShowcaseNavMenuPageEntryProps) => {
  const { useNavPageBoards } = usePublicShowcaseContext();
  const { boards } = useNavPageBoards({ pageCollectionId: entry.pageId });

  return (
    <>
      <PublicShowcaseNavMenuItem entry={entry} />
      {boards.map((board) => (
        <PublicShowcaseNavMenuBoardItem board={board} key={board.id} pageId={entry.pageId} slug={entry.slug} />
      ))}
    </>
  );
});

PublicShowcaseNavMenuPageEntry.displayName = 'PublicShowcaseNavMenuPageEntry';
